import React from "react";
import { motion } from "framer-motion";
import { FiPhone, FiEdit3, FiTrash2 } from "react-icons/fi";
import type { VoiceAgent } from "../voice.types";
import "../../../styles/Voice.css";

const statusLabel: Record<VoiceAgent["status"], string> = {
  online: "Online",
  idle: "Idle",
  offline: "Offline",
};

interface AgentCardProps {
  agent: VoiceAgent;
  assignedPhone: string | null;
  onEdit: (agent: VoiceAgent) => void;
  onDelete?: (agent: VoiceAgent) => void;
}

const AgentCard: React.FC<AgentCardProps> = ({
  agent,
  assignedPhone,
  onEdit,
  onDelete,
}) => {
  return (
    <motion.div
      className="vac"
      layout
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.97 }}
      transition={{ duration: 0.15 }}
    >
      {/* Top: avatar + name + phone + action icons */}
      <div className="vac__top">
        <div className="vac__avatar" style={{ background: agent.color }}>
          {agent.initials}
        </div>
        <div className="vac__title-group">
          <div className="vac__name">{agent.name}</div>
          <div className="vac__phone">
            <FiPhone size={11} />
            {assignedPhone ?? "No phone assigned"}
          </div>
        </div>
        <div className="vac__actions">
          <button className="vac__action-btn vac__action-btn--edit" onClick={() => onEdit(agent)} title="Edit Agent">
            <FiEdit3 size={15} />
          </button>
          {onDelete && (
            <button className="vac__action-btn vac__action-btn--delete" onClick={() => onDelete(agent)} title="Delete Agent">
              <FiTrash2 size={15} />
            </button>
          )}
        </div>
      </div>

      {/* Status pill */}
      <div className="vac__footer">
        <span className={`vac__status-pill vac__status-pill--${agent.status}`}>
          <span className="vac__status-dot" />
          {statusLabel[agent.status]}
        </span>
      </div>
    </motion.div>
  );
};

export default AgentCard;
